import BasicInformation from './BasicInformation';
import InvestorQualification from './InvestorQualification';
import InvestorAffiliations from './InvestorAffiliations';
import InvestmentPreferences from './InvestmentPreferences';
import InvestorSuitability from './InvestorSuitability';
import InvestorVerification from './InvestorVerification';
import InvestorFundQualification from './InvestorFundQualification';

const routes = {
  '/account/basic-information': {
    component: BasicInformation,
    title: 'Basic Information',
    navTitle: 'Basic Information',
  },
  '/account/qualification': {
    component: InvestorQualification,
    title: 'Qualification',
    navTitle: 'Qualification',
  },
  // '/account/fund-qualification': {
  //   component: InvestorFundQualification,
  //   title: 'Fund Investor Qualification',
  //   navTitle: 'Fund Investor Qualification',
  // },
  '/account/suitability': {
    component: InvestorSuitability,
    title: 'Suitability',
    navTitle: 'Investor Suitability',
  },
  '/account/affiliations': {
    component: InvestorAffiliations,
    title: 'Affiliations',
    navTitle: 'Investor Affiliations',
  },
  '/account/preferences': {
    component: InvestmentPreferences,
    title: 'Preferences',
    navTitle: 'Investor Preferences',
  },
  '/account/verification': {
    component: InvestorVerification,
    title: 'Verification',
    navTitle: 'Investor Verification',
  },
};

export default routes;



// WEBPACK FOOTER //
// ./src/components/Account/accountRoutes.js